import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SimpleDropdown from 'generic/SimpleDropdown/SimpleDropdown.react';
import SelectableDateRange from 'generic/SelectableDateRange/SelectableDateRange.react';
import {dateRangeOptionsWithoutAllTime} from 'generic/SelectableDateRange/shared';

import teacherClassroomScopeStore from './TeacherClassroomScope.store';
import './teacher-classroom-scope.scss';

export default function TeacherClassroomScope(props) {
  const [options, activeOptionId] = teacherClassroomScopeStore.getSubjectOptions();
  return (
    <div className={classnames('teacher-classroom-scope-options', props.className)}>
      <SimpleDropdown
        activeItemId={activeOptionId}
        fullWidth
        label='Subject'
        storeName={teacherClassroomScopeStore.getSubjectsDropdownStoreName()}
        className='teacher-classroom-scope-options__dropdown'
        options={options}
      />
      <SimpleDropdown
        fullWidth
        label='Attempt Number'
        storeName={teacherClassroomScopeStore.getAttemptNumberDropdownStoreName()}
        className='teacher-classroom-scope-options__dropdown'
        options={teacherClassroomScopeStore.getAttemptNumberOptions()}
      />
      <SelectableDateRange
        className='teacher-classroom-scope-options__selectable-date-range'
        defaultDateRange={teacherClassroomScopeStore.getDefaultDateRange()}
        label='Date'
        options={dateRangeOptionsWithoutAllTime}
        shouldShowErrors
        storeName={teacherClassroomScopeStore.getSelectableDateRangeStore().getName()}
      />
    </div>
  );
}

TeacherClassroomScope.propTypes = {
  className: PropTypes.string
};
